import { render } from "./qysds.vue?vue&type=template&id=00ca3d1e&scoped=true"
import script from "./qysds.vue?vue&type=script&lang=js"
export * from "./qysds.vue?vue&type=script&lang=js"

import "./qysds.vue?vue&type=style&index=0&id=00ca3d1e&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ca3d1e"]])

export default __exports__